import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import {
  AuthProvider,
  ProfileProvider,
  SocketProvider,
  NotificationProvider,
  ConnectionsProvider,
  UIProvider,
  SearchProvider,
} from './context';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/shared/ErrorBoundary';
import './App.css';

/**
 * Main App Component
 * Wraps the entire application with necessary providers and routing
 *
 * Provider hierarchy (order matters):
 * 1. BrowserRouter - Routing
 * 2. AuthProvider - Authentication state
 * 3. ProfileProvider - User profile data
 * 4. SocketProvider - WebSocket connections (requires auth)
 * 5. NotificationProvider - Notifications (requires socket)
 * 6. ConnectionsProvider - Connections/followers (requires socket)
 * 7. SearchProvider - Search functionality
 * 8. UIProvider - UI state (modals, loading states)
 */
function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ProfileProvider>
            <SocketProvider>
              <NotificationProvider>
                <ConnectionsProvider>
                  <SearchProvider>
                    <UIProvider>
                      <div className="App">
                        <AppRoutes />

                      {/* Global Toast Notifications */}
                      <Toaster
                        position="top-right"
                        toastOptions={{
                          duration: 3000,
                          style: {
                            background: '#363636',
                            color: '#fff',
                          },
                          success: {
                            duration: 3000,
                            iconTheme: {
                              primary: '#10B981',
                              secondary: '#fff',
                            },
                          },
                          error: {
                            duration: 4000,
                            iconTheme: {
                              primary: '#EF4444',
                              secondary: '#fff',
                            },
                          },
                        }}
                      />
                      </div>
                    </UIProvider>
                  </SearchProvider>
                </ConnectionsProvider>
              </NotificationProvider>
            </SocketProvider>
          </ProfileProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
